export const localStorageKeys = {
  ZIP_CODE: 'zipcode',
  KITCHEN_NAMES: 'kitchenNames',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  FINGER_PRINT_USER: 'fingerPrint',
};
export const API_NETWORK_ERROR = 'Network Error';
export const ERROR_404_MSG = "Oops ! We're Sorry something went wrong";

export const verbiage = {
  CONGRATS_MSG:
    'Good news! We’re active in your area, and limited openings remain in your business category. Complete your registration now to confirm your spot.',
  FUTURE_CUST_MSG:
    'We currently don’t have service or availability in your selected category or area. Please share your email, and we’ll reach out as soon as a spot opens up near you.',
  FUTURE_CUST_SUBTITLE_MSG: 'We will update as soon as we have avalablity arises',
};

export const orderStatusMapping = {
  pending: 'Pending',
  'order canceled by customer': 'Canceled by customer',
  'order accepted by kitchen': 'Preparing',
  'order canceled by kitchen': 'Canceled by kitchen',
  'order canceled by computer no response from kitchen': 'Canceled',
  'super admin canceled the order': 'Canceled',

  'order ready for pickup': 'Searching for driver',
  'driver pickup pending': 'Driver is arriving soon',
  'driver picked the order': 'Driver Picked order',
  order_unpicked_by_driver: 'Searching for driver',
  'order picked in store by customer': 'Order picked up by customer',

  'driver is at the door': 'Driver at the door',
  'order delivered': 'Delivered',
  order_damaged_while_delivery: 'Order damaged — refund processed',
};
